"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareValues = void 0;
var formik_1 = require("formik");
var ramda_1 = require("ramda");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var __1 = require("..");
var __2 = require("../../../..");
var components_1 = require("../../components");
var Label_1 = __importDefault(require("../../components/Label"));
var Form_1 = __importDefault(require("../../Form"));
var PridatZadavateleField_1 = require("../ZadavatelField/PridatZadavateleField");
var PridatPodilejiciOsobuPopup_1 = require("../ZpracovatelField/components/PridatPodilejiciOsobuPopup");
var PridatZpracovatelePopup_1 = __importDefault(require("../ZpracovatelField/components/PridatZpracovatelePopup"));
var SelectRoleSpolupracujiciOsoby_1 = __importDefault(require("./components/SelectRoleSpolupracujiciOsoby"));
var SelectTypOsoby_1 = __importDefault(require("./components/SelectTypOsoby"));
var SpolupracujiciOsoba_1 = __importDefault(require("./components/SpolupracujiciOsoba"));
var BorderDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var $hasError = _a.$hasError;
    return $hasError && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border: 2px solid #ba0d23;\n      border-radius: 4px;\n      height: 50px;\n      padding-top: 12px;\n      padding-left: 2px;\n    "], ["\n      border: 2px solid #ba0d23;\n      border-radius: 4px;\n      height: 50px;\n      padding-top: 12px;\n      padding-left: 2px;\n    "])));
});
var StyledLabel = styled_components_1.default(function (props) { return react_1.default.createElement(Label_1.default, __assign({}, props)); })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-self: flex-start;\n"], ["\n  align-self: flex-start;\n"])));
var StyledPopup = styled_components_1.default(function (props) { return react_1.default.createElement(__2.Popup, __assign({}, props)); })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  &-content {\n    padding: 2em 0 0 0;\n  }\n"], ["\n  &-content {\n    padding: 2em 0 0 0;\n  }\n"])));
var FlexColumn = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var StyledDiv = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin: 6px 0 20px 0;\n"], ["\n  margin: 6px 0 20px 0;\n"])));
var CenteredDiv = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  margin-top: 2em;\n  display: flex;\n  justify-content: center;\n"], ["\n  margin-top: 2em;\n  display: flex;\n  justify-content: center;\n"])));
var PopupDiv = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  max-height: 70vh;\n  overflow: auto;\n"], ["\n  max-height: 70vh;\n  overflow: auto;\n"])));
var prepareValues = function (formResult, fieldLength) {
    var newValue = {};
    var foValue = {};
    var idCounter;
    if (formResult.isKanclUstavFopLogged && fieldLength !== undefined && fieldLength >= 0) {
        idCounter = fieldLength === 0 ? -1 : fieldLength * -1 - 1;
    }
    // eslint-disable-next-line no-nested-ternary
    newValue.id = formResult.id !== undefined ? formResult.id : formResult.isKanclUstavFopLogged && formResult.typOsoby === __2.PosudkyTypOsoby.PravnickaOsoba ? idCounter : undefined;
    if (formResult.typOsoby === __2.PosudkyTypOsoby.FyzickaOsoba) {
        newValue.jmeno = formResult.jmeno;
        newValue.prijmeni = formResult.prijmeni;
        newValue.datumNarozeni = formResult.datumNarozeni;
        newValue.adresaPobytu = formResult.adresaPobytu;
        newValue.typOsoby = formResult.typOsoby;
        newValue.role = formResult.role;
        if (formResult.idNadrazenyKonzultant !== undefined)
            newValue.idNadrazenyKonzultant = formResult.idNadrazenyKonzultant;
        if (formResult.zvlastniDilciOtazky)
            newValue.zvlastniDilciOtazky = formResult.zvlastniDilciOtazky;
        if (formResult.duvodKPribrani)
            newValue.duvodKPribrani = formResult.duvodKPribrani;
        if (formResult.titulPred)
            newValue.titulPred = formResult.titulPred;
        if (formResult.titulZa)
            newValue.titulZa = formResult.titulZa;
    }
    if (formResult.typOsoby === __2.PosudkyTypOsoby.FyzickaOsobaPodnikajici) {
        newValue.jmeno = formResult.jmeno;
        newValue.prijmeni = formResult.prijmeni;
        newValue.ico = formResult.ico.toString();
        newValue.adresaSidla = formResult.adresaSidla;
        newValue.typOsoby = formResult.typOsoby;
        newValue.role = formResult.role;
        if (formResult.titulPred)
            newValue.titulPred = formResult.titulPred;
        if (formResult.titulZa)
            newValue.titulZa = formResult.titulZa;
    }
    if (formResult.typOsoby === __2.PosudkyTypOsoby.PravnickaOsoba) {
        newValue.nazev = formResult.nazev;
        newValue.ico = formResult.ico.toString();
        newValue.adresaSidla = formResult.adresaSidla;
        newValue.typOsoby = formResult.typOsoby;
        newValue.role = formResult.role;
    }
    if (formResult.role === __2.PosudkyRoleOsoby.Konzultant) {
        newValue.zvlastniDilciOtazky = formResult.zvlastniDilciOtazky;
        newValue.duvodKPribrani = formResult.duvodKPribrani;
        if (formResult.isKanclUstavFopLogged && formResult.typOsoby === __2.PosudkyTypOsoby.PravnickaOsoba) {
            foValue.jmeno = formResult.jmeno;
            foValue.prijmeni = formResult.prijmeni;
            foValue.datumNarozeni = formResult.datumNarozeni;
            foValue.adresaPobytu = formResult.adresaPobytu;
            foValue.zvlastniDilciOtazky = formResult.zvlastniDilciOtazky;
            foValue.duvodKPribrani = formResult.duvodKPribrani;
            foValue.id = newValue.id - 1;
            foValue.idNadrazenyKonzultant = newValue.id;
            foValue.druh = { id: __2.PosudkyTypOsoby.FyzickaOsoba };
            foValue.role = { id: formResult.role };
            newValue.isNadrazenaPO = true;
            if (formResult.titulPred)
                foValue.titulPred = formResult.titulPred;
            if (formResult.titulZa)
                foValue.titulZa = formResult.titulZa;
        }
    }
    newValue.role = { id: formResult.role };
    newValue.druh = { id: formResult.typOsoby };
    idCounter -= 1;
    return formResult.isKanclUstavFopLogged && formResult.typOsoby === __2.PosudkyTypOsoby.PravnickaOsoba ? [newValue, foValue] : newValue;
};
exports.prepareValues = prepareValues;
var validate = function (values) {
    var jmenoLens = ramda_1.lensPath(['jmeno']);
    var prijmenilLens = ramda_1.lensPath(['prijmeni']);
    var narozeniLens = ramda_1.lensPath(['datumNarozeni']);
    var adresaPobytuLens = ramda_1.lensPath(['adresaPobytu']);
    var icoLens = ramda_1.lensPath(['ico']);
    var adresaSidlaLens = ramda_1.lensPath(['adresaSidla']);
    var nazevLens = ramda_1.lensPath(['nazev']);
    var druhLens = ramda_1.lensPath(['typOsoby']);
    var roleLens = ramda_1.lensPath(['role']);
    var otazkyLens = ramda_1.lensPath(['zvlastniDilciOtazky']);
    var duvodyLens = ramda_1.lensPath(['duvodKPribrani']);
    if (!ramda_1.view(druhLens, values)) {
        return ramda_1.pipe(ramda_1.set(druhLens, 'Typ osoby nebyl vybrán.'))({});
    }
    if (!ramda_1.view(roleLens, values)) {
        return ramda_1.pipe(ramda_1.set(roleLens, 'Role nebyla vybrána.'))({});
    }
    if (ramda_1.view(roleLens, values) === __2.PosudkyRoleOsoby.Konzultant) {
        if (!ramda_1.view(otazkyLens, values) || !ramda_1.view(duvodyLens, values)) {
            var pipe1 = ramda_1.pipe(ramda_1.when(function () { return !ramda_1.view(otazkyLens, values); }, ramda_1.set(otazkyLens, 'Zvláštní dílčí otázky jsou povinné')), ramda_1.when(function () { return !ramda_1.view(duvodyLens, values); }, ramda_1.set(duvodyLens, 'Důvody k přibrání jsou povinné')))({});
            return Object.keys(pipe1).length > 0 ? __assign(__assign({}, pipe1), { dot: '' }) : pipe1;
        }
    }
    if (ramda_1.view(druhLens, values) === __2.PosudkyTypOsoby.FyzickaOsoba) {
        var pipe1 = ramda_1.pipe(ramda_1.when(function () { return !ramda_1.view(jmenoLens, values); }, ramda_1.set(jmenoLens, 'Jméno je povinné')), ramda_1.when(function () { return !ramda_1.view(prijmenilLens, values); }, ramda_1.set(prijmenilLens, 'Příjmení je povinné')), ramda_1.when(function () { return !ramda_1.view(narozeniLens, values); }, ramda_1.set(narozeniLens, 'Datum narození je povinné')), ramda_1.when(function () { return !ramda_1.view(adresaPobytuLens, values); }, ramda_1.set(adresaPobytuLens, 'Adresa pobytu je povinná')))({});
        return Object.keys(pipe1).length > 0 ? __assign(__assign({}, pipe1), { dot: '' }) : pipe1;
    }
    if (ramda_1.view(druhLens, values) === __2.PosudkyTypOsoby.FyzickaOsobaPodnikajici) {
        var pipe1 = ramda_1.pipe(ramda_1.when(function () { return !ramda_1.view(jmenoLens, values); }, ramda_1.set(jmenoLens, 'Jméno je povinné')), ramda_1.when(function () { return !ramda_1.view(prijmenilLens, values); }, ramda_1.set(prijmenilLens, 'Příjmení je povinné')), ramda_1.when(function () { return !ramda_1.view(icoLens, values); }, ramda_1.set(icoLens, 'IČO je povinné')), ramda_1.when(function () { return !ramda_1.view(adresaSidlaLens, values); }, ramda_1.set(adresaSidlaLens, 'Adresa sídla je povinná')))({});
        return Object.keys(pipe1).length > 0 ? __assign(__assign({}, pipe1), { dot: '' }) : pipe1;
    }
    if (ramda_1.view(druhLens, values) === __2.PosudkyTypOsoby.PravnickaOsoba) {
        var pipe1 = ramda_1.pipe(ramda_1.when(function () { return !ramda_1.view(nazevLens, values); }, ramda_1.set(nazevLens, 'Název je povinný')), ramda_1.when(function () { return !ramda_1.view(icoLens, values); }, ramda_1.set(icoLens, 'IČO je povinné')), ramda_1.when(function () { return !ramda_1.view(adresaSidlaLens, values); }, ramda_1.set(adresaSidlaLens, 'Adresa sídla je povinná')), ramda_1.when(function () { return !ramda_1.view(jmenoLens, values) && values.isKanclUstavFopLogged; }, ramda_1.set(jmenoLens, 'Jméno je povinné')), ramda_1.when(function () { return !ramda_1.view(prijmenilLens, values) && values.isKanclUstavFopLogged; }, ramda_1.set(prijmenilLens, 'Příjmení je povinné')), ramda_1.when(function () { return !ramda_1.view(narozeniLens, values) && values.isKanclUstavFopLogged; }, ramda_1.set(narozeniLens, 'Datum narození je povinné')), ramda_1.when(function () { return !ramda_1.view(adresaPobytuLens, values) && values.isKanclUstavFopLogged; }, ramda_1.set(adresaPobytuLens, 'Adresa pobytu je povinná')))({});
        return Object.keys(pipe1).length > 0 ? __assign(__assign({}, pipe1), { dot: '' }) : pipe1;
    }
};
var PridatSpolupracujiciOsobuField = function (_a) {
    var _b;
    var name = _a.name, label = _a.label, datumZadani = _a.datumZadani, readOnly = _a.readOnly;
    var _c = formik_1.useField(name), field = _c[0], meta = _c[1], helpers = _c[2];
    var _d = formik_1.useField('zpracovatel'), zpracovateleField = _d[0], zpracovateleHelpers = _d[2];
    var zpracovateleValue = zpracovateleField.value || [];
    var isOpen = __2.useBoolean(false);
    var _e = react_1.useState('jinaOsoba'), activeTab = _e[0], setActiveTab = _e[1];
    var adresaPlaceHolder = '';
    var value = field.value || [];
    var _f = react_1.useState(undefined), indexToEdit = _f[0], setIndexToEdit = _f[1];
    var _g = react_1.useState(), valueToEdit = _g[0], setValueToEdit = _g[1];
    var role = __2.useCiselnik('posudkyRole').data;
    var druhyOsoby = __2.useCiselnik('posudkyDruhyOsob').data;
    var _h = react_1.useState(undefined), selectedZpracovatel = _h[0], setSelectedZpracovatel = _h[1];
    var _j = react_1.useState([]), znalciList = _j[0], setZnalciList = _j[1];
    var apiUrl = __2.useConfig().apiUrl;
    var getZnalecClenstviJSON = __2.useGetJSON(apiUrl + "/ZnalecClenstvi/");
    var token = __2.useToken();
    var _k = (token === null || token === void 0 ? void 0 : token.getDataFromToken()) || {}, roleIds = _k.roleIds, mandat = _k.mandat;
    var kancelarUstavLogged = __2.isInRole([__2.Role.znalec], roleIds) && (mandat === 'Znalecká kancelář' || mandat === 'Znalecký ústav');
    var fopLogged = __2.isInRole([__2.Role.znalec], roleIds) && mandat === 'Znalec';
    var editorLogged = __2.isInRole([__2.Role.Editor], roleIds) && mandat === 'Interní pracovník';
    var FyzickaOsobaForm = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(PridatZadavateleField_1.CoupledFields, null,
            react_1.default.createElement(__1.TextFieldLabeled, { label: "Titul p\u0159ed jm\u00E9nem", name: "titulPred" }),
            react_1.default.createElement(__1.TextFieldLabeled, { label: "Titul za jm\u00E9nem", name: "titulZa" }),
            react_1.default.createElement(__1.TextFieldLabeled, { label: "Jm\u00E9no, p\u0159\u00EDpadn\u011B jm\u00E9na", name: "jmeno" }),
            react_1.default.createElement(__1.TextFieldLabeled, { label: "P\u0159\u00EDjmen\u00ED", name: "prijmeni" })),
        react_1.default.createElement(PridatZadavateleField_1.CoupledFields, null,
            react_1.default.createElement(__1.TextFieldLabeled, { label: "Adresa bydli\u0161t\u011B", name: "adresaPobytu", placeholder: adresaPlaceHolder }),
            react_1.default.createElement(__1.DateFieldLabeled, { label: "Datum narozen\u00ED", name: "datumNarozeni", maxDate: new Date() }))));
    var FyzickaOsobaPodnikajiciForm = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(PridatZadavateleField_1.CoupledFields, null,
            react_1.default.createElement(__1.TextFieldLabeled, { label: "Titul p\u0159ed jm\u00E9nem", name: "titulPred" }),
            react_1.default.createElement(__1.TextFieldLabeled, { label: "Titul za jm\u00E9nem", name: "titulZa" }),
            react_1.default.createElement(__1.TextFieldLabeled, { label: "Jm\u00E9no, p\u0159\u00EDpadn\u011B jm\u00E9na", name: "jmeno" }),
            react_1.default.createElement(__1.TextFieldLabeled, { label: "P\u0159\u00EDjmen\u00ED", name: "prijmeni" })),
        react_1.default.createElement(PridatZadavateleField_1.CoupledFields, null,
            react_1.default.createElement(FlexColumn, null,
                react_1.default.createElement(PridatZadavateleField_1.MarginLabel, { htmlFor: "ico" }, "I\u010CO"),
                react_1.default.createElement(__1.IcoField, { name: "ico" })),
            react_1.default.createElement(__1.TextFieldLabeled, { label: "Adresa s\u00EDdla", name: "adresaSidla", placeholder: adresaPlaceHolder }))));
    var PravnickaOsobaForm = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(PridatZadavateleField_1.CoupledFields, null,
            react_1.default.createElement(__1.TextFieldLabeled, { label: "N\u00E1zev", name: "nazev" })),
        react_1.default.createElement(PridatZadavateleField_1.CoupledFields, null,
            react_1.default.createElement(FlexColumn, null,
                react_1.default.createElement(PridatZadavateleField_1.MarginLabel, { htmlFor: "ico" }, "I\u010CO"),
                react_1.default.createElement(__1.IcoField, { name: "ico" })),
            react_1.default.createElement(__1.TextFieldLabeled, { label: "Adresa s\u00EDdla", name: "adresaSidla", placeholder: adresaPlaceHolder }))));
    var getForm = function (druh) {
        if (druh === __2.PosudkyTypOsoby.FyzickaOsobaPodnikajici)
            return FyzickaOsobaPodnikajiciForm;
        if (druh === __2.PosudkyTypOsoby.PravnickaOsoba)
            return PravnickaOsobaForm;
        return FyzickaOsobaForm;
    };
    /* #11887
    const zapisujeZnalecne = (item: any) => {
      // prihlasena kancelar/ustav - znalec je clenem
      return item.role.id === PosudkyRoleOsoby.ZnalecPodilejiciNaZpracovani && item.podiliSeJakoClen.toString() === entityId ? item.znalecne || { platceDph: 1 } : undefined;
    }; */
    var activateEditMode = function (i) { return __awaiter(void 0, void 0, void 0, function () {
        var updateValue, clenove, response, podrizenyFOFound, editOrganizace, clenove, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIndexToEdit(i);
                    updateValue = kancelarUstavLogged || fopLogged ? value.filter(function (v) { return [__2.PosudkyRoleOsoby.Konzultant].includes(v.role.id); })[i] : value[i];
                    if (updateValue.idSubjekt || updateValue.idExterniOsoba)
                        setActiveTab('clenstvi');
                    else
                        setActiveTab('jinaOsoba');
                    if (!!updateValue.podiliSeJakoClen) return [3 /*break*/, 4];
                    if (!updateValue.idSubjekt) return [3 /*break*/, 3];
                    clenove = updateValue.clenove;
                    if (!!(clenove === null || clenove === void 0 ? void 0 : clenove.length)) return [3 /*break*/, 2];
                    return [4 /*yield*/, getZnalecClenstviJSON({ idZnalec: updateValue.idSubjekt })];
                case 1:
                    response = _a.sent();
                    if (__2.isRight(response))
                        setZnalciList(response.value.clenove);
                    return [3 /*break*/, 3];
                case 2:
                    setZnalciList(clenove);
                    _a.label = 3;
                case 3:
                    if ((kancelarUstavLogged || fopLogged) && value.filter(function (v) { return v.role.id === __2.PosudkyRoleOsoby.Konzultant; })[i].druh.id === __2.PosudkyTypOsoby.PravnickaOsoba) {
                        podrizenyFOFound = value.find(function (v) { return v.idNadrazenyKonzultant === value.filter(function (x) { return x.role.id === __2.PosudkyRoleOsoby.Konzultant; })[i].id; });
                        setValueToEdit(__assign(__assign({}, updateValue), { jmeno: podrizenyFOFound.jmeno, prijmeni: podrizenyFOFound.prijmeni, adresaPobytu: podrizenyFOFound.adresaPobytu, datumNarozeni: podrizenyFOFound.datumNarozeni, zvlastniDilciOtazky: podrizenyFOFound.zvlastniDilciOtazky, duvodKPribrani: podrizenyFOFound.duvodKPribrani, titulPred: podrizenyFOFound.titulPred ? podrizenyFOFound.titulPred : undefined, titulZa: podrizenyFOFound.titulZa ? podrizenyFOFound.titulZa : undefined }));
                    }
                    else {
                        setValueToEdit(updateValue);
                    }
                    return [3 /*break*/, 7];
                case 4:
                    editOrganizace = __spreadArrays(value, zpracovateleValue).find(function (o) { return o.idSubjekt === updateValue.podiliSeJakoClen; });
                    setSelectedZpracovatel(editOrganizace);
                    setValueToEdit(editOrganizace);
                    clenove = editOrganizace.clenove;
                    if (!!(clenove === null || clenove === void 0 ? void 0 : clenove.length)) return [3 /*break*/, 6];
                    return [4 /*yield*/, getZnalecClenstviJSON({ idZnalec: editOrganizace.idSubjekt })];
                case 5:
                    response = _a.sent();
                    if (__2.isRight(response))
                        setZnalciList(response.value.clenove);
                    return [3 /*break*/, 7];
                case 6:
                    setZnalciList(clenove);
                    _a.label = 7;
                case 7:
                    isOpen.setTrue();
                    return [2 /*return*/];
            }
        });
    }); };
    var deactivatePopup = function () {
        setIndexToEdit(undefined);
        setValueToEdit(undefined);
        setZnalciList([]);
        setSelectedZpracovatel(undefined);
        isOpen.setFalse();
        setActiveTab('jinaOsoba');
    };
    var handleSubmit = function (formResult, formikHelpers) { return __awaiter(void 0, void 0, void 0, function () {
        var existFO, removeIndex_1, newValues, podrizenyFOIndex_1, updatedFOValue, nadrazenyPOIndex, updatedPOValue, trueIndex, newValues;
        return __generator(this, function (_a) {
            try {
                formikHelpers.setStatus(undefined);
                if (indexToEdit !== undefined) {
                    if ((kancelarUstavLogged || fopLogged) && formResult.typOsoby === __2.PosudkyTypOsoby.PravnickaOsoba && formResult.role === __2.PosudkyRoleOsoby.Konzultant) {
                        existFO = value
                            .filter(function (x) { return [__2.PosudkyRoleOsoby.Konzultant, __2.PosudkyRoleOsoby.DalsiOsoba, __2.PosudkyRoleOsoby.OsobaProstrednictvimKtereKonzultantPosuzuval].includes(x.role.id); })
                            .find(function (v) {
                            return v.idNadrazenyKonzultant !== undefined &&
                                v.idNadrazenyKonzultant ===
                                    value.filter(function (x) {
                                        return [__2.PosudkyRoleOsoby.Konzultant, __2.PosudkyRoleOsoby.DalsiOsoba, __2.PosudkyRoleOsoby.OsobaProstrednictvimKtereKonzultantPosuzuval].includes(x.role.id);
                                    })[indexToEdit].id;
                        });
                        if (!existFO) {
                            removeIndex_1 = value.findIndex(function (v) {
                                return v.jmeno ===
                                    value.filter(function (x) { return [__2.PosudkyRoleOsoby.Konzultant, __2.PosudkyRoleOsoby.DalsiOsoba, __2.PosudkyRoleOsoby.OsobaProstrednictvimKtereKonzultantPosuzuval].includes(x.role.id); })[indexToEdit].jmeno;
                            });
                            newValues = exports.prepareValues(formResult, value.length);
                            helpers.setValue(Array.isArray(newValues) ? __spreadArrays(value.filter(function (_, i) { return i !== removeIndex_1; }), newValues) : __spreadArrays(value, [newValues]));
                        }
                        else {
                            podrizenyFOIndex_1 = value.findIndex(function (v) { return v.idNadrazenyKonzultant === formResult.id; });
                            updatedFOValue = ramda_1.over(ramda_1.lensIndex(podrizenyFOIndex_1), function (v) { return (__assign(__assign({}, v), { jmeno: formResult.jmeno, prijmeni: formResult.prijmeni, adresaPobytu: formResult.adresaPobytu, datumNarozeni: formResult.datumNarozeni, zvlastniDilciOtazky: formResult.zvlastniDilciOtazky, duvodKPribrani: formResult.duvodKPribrani, titulPred: formResult.titulPred ? formResult.titulPred : undefined, titulZa: formResult.titulZa ? formResult.titulZa : undefined })); })(value);
                            nadrazenyPOIndex = value.findIndex(function (v) { return v.id === value[podrizenyFOIndex_1].idNadrazenyKonzultant; });
                            updatedPOValue = ramda_1.over(ramda_1.lensIndex(nadrazenyPOIndex), function (v) { return (__assign(__assign({}, v), { nazev: formResult.nazev, ico: formResult.ico, adresaSidla: formResult.adresaSidla, zvlastniDilciOtazky: formResult.zvlastniDilciOtazky, duvodKPribrani: formResult.duvodKPribrani })); })(updatedFOValue);
                            helpers.setValue(updatedPOValue);
                        }
                    }
                    else {
                        trueIndex = value.findIndex(function (v) {
                            return v.id ===
                                value.filter(function (x) { return [__2.PosudkyRoleOsoby.Konzultant, __2.PosudkyRoleOsoby.DalsiOsoba, __2.PosudkyRoleOsoby.OsobaProstrednictvimKtereKonzultantPosuzuval].includes(x.role.id); })[indexToEdit].id;
                        });
                        helpers.setValue(ramda_1.set(ramda_1.lensIndex(kancelarUstavLogged || fopLogged ? trueIndex : indexToEdit), exports.prepareValues(formResult), value));
                    }
                }
                else {
                    newValues = exports.prepareValues(formResult, value.length);
                    helpers.setValue(Array.isArray(newValues) ? __spreadArrays(value, newValues) : __spreadArrays(value, [newValues]));
                }
                isOpen.setFalse();
                setIndexToEdit(undefined);
                setValueToEdit(undefined);
                return [2 /*return*/];
            }
            catch (e) {
                formikHelpers.setStatus({ type: 'error', message: e.message });
            }
            return [2 /*return*/];
        });
    }); };
    var handleDeleteSpolupracujiciOsoba = function (i) {
        var _a, _b, _c;
        var toRemove = kancelarUstavLogged || fopLogged
            ? value.filter(function (v) { return [__2.PosudkyRoleOsoby.Konzultant, __2.PosudkyRoleOsoby.DalsiOsoba, __2.PosudkyRoleOsoby.OsobaProstrednictvimKtereKonzultantPosuzuval].includes(v.role.id); })[i]
            : value[i];
        var filtered = value.filter(function (po) { return po !== toRemove; });
        if (toRemove.podiliSeJakoClen) {
            if (value.filter(function (po) { return po.podiliSeJakoClen === toRemove.podiliSeJakoClen; }).length < 2) {
                zpracovateleHelpers.setValue(zpracovateleValue.filter(function (z) { return z.idSubjekt !== toRemove.podiliSeJakoClen; }));
                filtered = filtered.filter(function (po) { return po.idSubjekt !== toRemove.podiliSeJakoClen; });
            }
            else
                zpracovateleHelpers.setValue(zpracovateleValue);
        }
        if (toRemove.role.id === __2.PosudkyRoleOsoby.ZnaleckaKancelarPodilejiciNaZpracovani || toRemove.role.id === __2.PosudkyRoleOsoby.ZnaleckyUstavPodilejiciNaZpracovani) {
            filtered = filtered.filter(function (po) { return po.podiliSeJakoClen !== toRemove.idSubjekt; });
        }
        if ((kancelarUstavLogged || fopLogged) && ((_a = toRemove.druh) === null || _a === void 0 ? void 0 : _a.id) === __2.PosudkyTypOsoby.FyzickaOsoba && toRemove.idNadrazenyKonzultant !== undefined) {
            filtered = filtered.filter(function (v) { return v.id !== toRemove.idNadrazenyKonzultant; });
        }
        if ((kancelarUstavLogged || fopLogged) && ((_b = toRemove.druh) === null || _b === void 0 ? void 0 : _b.id) === __2.PosudkyTypOsoby.PravnickaOsoba && ((_c = toRemove.role) === null || _c === void 0 ? void 0 : _c.id) === __2.PosudkyRoleOsoby.Konzultant) {
            filtered = filtered.filter(function (v) { return v.idNadrazenyKonzultant !== toRemove.id; });
        }
        helpers.setValue(filtered);
    };
    var handleSetZpracovatelPodilejci = function (items) {
        var jeZpracovatel = selectedZpracovatel.role.id === __2.PosudkyRoleOsoby.ZnaleckaKancelar || selectedZpracovatel.role.id === __2.PosudkyRoleOsoby.ZnaleckyUstav;
        var zpracovatelClenstvi = __assign(__assign({}, selectedZpracovatel), { clenove: znalciList });
        if (jeZpracovatel) {
            zpracovateleValue[zpracovateleValue.indexOf(selectedZpracovatel)] = zpracovatelClenstvi;
            zpracovateleHelpers.setValue(zpracovateleValue);
        }
        var znalecneItems = items.map(function (i) {
            return __assign({}, i);
        });
        if (indexToEdit === undefined) {
            helpers.setValue(__spreadArrays(value, [zpracovatelClenstvi], znalecneItems));
        }
        else {
            var changeId_1 = valueToEdit.idSubjekt;
            var editedValueIndex = value.indexOf(value.find(function (o) { return o.idSubjekt === valueToEdit.idSubjekt; }));
            if (editedValueIndex >= 0) {
                value[editedValueIndex] = zpracovatelClenstvi;
            }
            helpers.setValue(__spreadArrays(value.filter(function (z) { return z.podiliSeJakoClen !== changeId_1; }), znalecneItems));
        }
        setSelectedZpracovatel(undefined);
        setZnalciList([]);
        setValueToEdit(undefined);
        setIndexToEdit(undefined);
        isOpen.setFalse();
    };
    var handleAddZpracovatelPodilejici = function (item, form) { return __awaiter(void 0, void 0, void 0, function () {
        var changeId_2, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(item.role.id === __2.PosudkyRoleOsoby.ZnalecPodilejiciNaZpracovani)) return [3 /*break*/, 1];
                    if (indexToEdit === undefined)
                        helpers.setValue(__spreadArrays(value, [item]));
                    else {
                        value[indexToEdit] = item;
                        changeId_2 = valueToEdit.idSubjekt;
                        helpers.setValue(__spreadArrays(value.filter(function (z) { return z.podiliSeJakoClen !== changeId_2; })));
                    }
                    isOpen.setFalse();
                    return [3 /*break*/, 3];
                case 1:
                    setSelectedZpracovatel(item);
                    form.setSubmitting(true);
                    return [4 /*yield*/, getZnalecClenstviJSON({ idZnalec: item.idSubjekt })];
                case 2:
                    response = _a.sent();
                    form.setSubmitting(false);
                    if (__2.isRight(response))
                        setZnalciList(response.value.clenove);
                    else
                        form.setStatus({ message: response.value.message, type: 'error' });
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(components_1.Field, { topAlign: true },
        (value === null || value === void 0 ? void 0 : value.length) ? react_1.default.createElement(StyledLabel, { htmlFor: name }, label) : react_1.default.createElement(Label_1.default, { htmlFor: name }, label),
        react_1.default.createElement(BorderDiv, { "$hasError": !!meta.error && !value },
            !!(value === null || value === void 0 ? void 0 : value.length) && (react_1.default.createElement(react_1.default.Fragment, null, (_b = value === null || value === void 0 ? void 0 : value.filter(function (v) { return (kancelarUstavLogged || fopLogged || editorLogged ? v.role.id === __2.PosudkyRoleOsoby.Konzultant : v); })) === null || _b === void 0 ? void 0 : _b.map(function (item, i) {
                return (react_1.default.createElement(SpolupracujiciOsoba_1.default, { item: item, index: i, onEdit: activateEditMode, onDelete: handleDeleteSpolupracujiciOsoba, role: role, readOnly: readOnly && !(item.podiliSeJakoClen && zpracovateleValue.find(function (zv) { return zv.idSubjekt === item.podiliSeJakoClen; })), isBlueBg: kancelarUstavLogged && item.role.id === __2.PosudkyRoleOsoby.Konzultant }));
            }))),
            react_1.default.createElement(__2.LinkButton, { type: "button", className: "button", onClick: isOpen.toggle, disabled: readOnly }, "P\u0159idat osoby"),
            react_1.default.createElement(StyledPopup, { open: isOpen.value, onClose: deactivatePopup },
                !kancelarUstavLogged && !fopLogged && react_1.default.createElement(PridatZadavateleField_1.Title, null,
                    indexToEdit !== undefined ? 'Upravit' : 'Přidat',
                    " spolupracuj\u00EDc\u00ED osobu"),
                react_1.default.createElement(__2.Tabs, { activeId: activeTab, onSelect: setActiveTab },
                    (indexToEdit === undefined || (valueToEdit === null || valueToEdit === void 0 ? void 0 : valueToEdit.idSubjekt)) && !kancelarUstavLogged && !fopLogged && (react_1.default.createElement(__2.Tabs.Tab, { id: "clenstvi", title: "Znalec / kancel\u00E1\u0159 / \u00FAstav" }, selectedZpracovatel ? (react_1.default.createElement(PridatPodilejiciOsobuPopup_1.PridatPodilejiciOsobuPopup, { addPodilejiciSe: handleSetZpracovatelPodilejci, znalciList: znalciList, selectedZpracovatel: selectedZpracovatel, selectedPodilejici: (valueToEdit === null || valueToEdit === void 0 ? void 0 : valueToEdit.idSubjekt) === selectedZpracovatel.idSubjekt ? value.filter(function (s) { return s.podiliSeJakoClen === selectedZpracovatel.idSubjekt; }) : undefined })) : (react_1.default.createElement(PridatZpracovatelePopup_1.default, { addZpracovatel: handleAddZpracovatelPodilejici, zpracovatele: __spreadArrays(value.filter(function (s) { return !s.podiliSeJakoClen; }), zpracovateleValue), datumZadani: datumZadani, podilejici: true, selectedZpracovatel: valueToEdit })))),
                    (indexToEdit === undefined || (indexToEdit !== undefined && !(valueToEdit === null || valueToEdit === void 0 ? void 0 : valueToEdit.idSubjekt))) && (react_1.default.createElement(__2.Tabs.Tab, { id: "jinaOsoba", title: kancelarUstavLogged || fopLogged ? 'Konzultant' : 'Jiná osoba' },
                        react_1.default.createElement(Form_1.default, { initialValues: valueToEdit ? __assign(__assign({}, valueToEdit), { role: valueToEdit.role.id, typOsoby: valueToEdit.druh.id }) : {}, onSubmit: handleSubmit, validate: validate }, function (_a) {
                            var isSubmitting = _a.isSubmitting, values = _a.values, setFieldValue = _a.setFieldValue;
                            if (((kancelarUstavLogged || fopLogged) && values.role !== __2.PosudkyRoleOsoby.Konzultant) ||
                                ((kancelarUstavLogged || fopLogged) && !values.isKanclUstavFopLogged)) {
                                setFieldValue('role', __2.PosudkyRoleOsoby.Konzultant);
                                setFieldValue('isKanclUstavFopLogged', kancelarUstavLogged || fopLogged);
                            }
                            return (react_1.default.createElement(PopupDiv, null,
                                react_1.default.createElement(__2.Padder, null,
                                    values.idNadrazenyKonzultant === undefined && values.isNadrazenaPO === undefined && (react_1.default.createElement(react_1.default.Fragment, null,
                                        react_1.default.createElement(Label_1.default, null, "Typ osoby"),
                                        react_1.default.createElement(PridatZadavateleField_1.CoupledFields, null,
                                            react_1.default.createElement(StyledDiv, null,
                                                react_1.default.createElement(SelectTypOsoby_1.default, { name: "typOsoby", filterResult: function (_a) {
                                                        var id = _a.id;
                                                        return id !== __2.PosudkyTypOsoby.OVM;
                                                    } }))))),
                                    getForm(values.typOsoby),
                                    !kancelarUstavLogged && !fopLogged && (react_1.default.createElement(react_1.default.Fragment, null,
                                        react_1.default.createElement(Label_1.default, null, "Role"),
                                        react_1.default.createElement(StyledDiv, null,
                                            react_1.default.createElement(SelectRoleSpolupracujiciOsoby_1.default, { name: "role", filterResult: function (r) {
                                                    return r.id === __2.PosudkyRoleOsoby.Konzultant ||
                                                        r.id === __2.PosudkyRoleOsoby.DalsiOsoba ||
                                                        r.id === __2.PosudkyRoleOsoby.OsobaProstrednictvimKtereKonzultantPosuzuval;
                                                } })))),
                                    values.role === __2.PosudkyRoleOsoby.Konzultant && (react_1.default.createElement(react_1.default.Fragment, null,
                                        react_1.default.createElement(StyledDiv, null,
                                            react_1.default.createElement(__1.TextAreaField, { label: "Zvl\u00E1\u0161tn\u00ED d\u00EDl\u010D\u00ED ot\u00E1zky", name: "zvlastniDilciOtazky" })),
                                        react_1.default.createElement(StyledDiv, null,
                                            react_1.default.createElement(__1.TextAreaField, { label: "D\u016Fvody k p\u0159ibr\u00E1n\u00ED", name: "duvodKPribrani" })),
                                        (kancelarUstavLogged || fopLogged) && values.typOsoby === __2.PosudkyTypOsoby.PravnickaOsoba && (react_1.default.createElement(react_1.default.Fragment, null,
                                            react_1.default.createElement(Label_1.default, null, "Fyzick\u00E1 osoba jej\u00EDm\u017E prost\u0159ednictv\u00EDm konzultant posuzoval zvl\u00E1\u0161tn\u00ED d\u00EDl\u010D\u00ED ot\u00E1zky"),
                                            react_1.default.createElement("div", { style: { marginTop: 20 } }, getForm(__2.PosudkyTypOsoby.FyzickaOsoba)))))),
                                    react_1.default.createElement(CenteredDiv, null,
                                        react_1.default.createElement(__2.Button, { type: "submit", primary: true, loading: isSubmitting, name: "pridatSpolupracujiciOsobu" }, indexToEdit !== undefined ? 'ULOŽIT ZMĚNY' : 'PŘIDAT OSOBU')))));
                        }))))))));
};
PridatSpolupracujiciOsobuField.defaultProps = {
    datumZadani: undefined,
    readOnly: undefined,
};
exports.default = PridatSpolupracujiciOsobuField;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
